import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"
import {Link} from 'gatsby';
// import { faAlignRight } from "@fortawesome/free-brands-svg-icons"

export default class App extends Component {
    state = {
        toggle:true
    }
    Toggle = () => {
        this.setState({toggle:!this.state.toggle})
    }
    render() {
        return (
          <>
          <nav className="navbar" role="navigation" aria-label="main navigation">
              <div className="navbar-brand">
        
              <a role="button" className="navbar-burger" aria-label="menu" aria-expanded="false" onClick={this.Toggle}>
              <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
              </a></div>
              <div className={this.state.toggle ? "navbar-menu" : "navbar-menu is-active"}>
                    <div className="navbar-start ml-6">
                    
                    
                        <Link className="navbar-item" to="/artworks">Artworks</Link>
                        <Link className="navbar-item" to="/artworksremoved">Artworks Removed</Link>
                        <Link className="navbar-item" to="/artists">Artists</Link>
                        <Link className="navbar-item" to="/map">Map</Link>
                        <Link className="navbar-item" to="/todo">To Do List</Link>
                        <Link className="navbar-item" to="/about">About...</Link>
                    
                    </div>
                    <div className="navbar-end">
                    <div className="navbar-item">
      <div className="buttons">
      <a className="button is-danger" href="https://www.instagram.com/publicartsg/">
      <span className="icon">
  <FontAwesomeIcon icon={faInstagram} />  
  </span>
      </a>
      <a className="button is-info" href="https://www.twitter.com/PublicArtSG">
  <span className="icon">
  <FontAwesomeIcon icon={faTwitter} />  
  </span>

</a>
      </div>
    </div>

                    </div>
                    </div>
              
              </nav>
          </>
        );
    }
}
